module.exports = __webpack_public_path__ + "static/img/google-calendar.e5aee9b7.svg";